import { Clipboard } from '@angular/cdk/clipboard'
import { computed, Directive, inject, input } from '@angular/core'

/**
 * Kopiert beim Klick auf einen Sendungslink die Liefer-PLZ, denn DHL fragt sie in der
 * Sendungsverfolgung ab, bevor es Details zeigt. Ohne PLZ bleibt die Zwischenablage unberuehrt,
 * statt mit einem Leerstring ueberschrieben zu werden. `hinweis()` ist der passende Tooltip-Satz.
 */
@Directive({
  selector: '[libPlzKopieren]',
  exportAs: 'libPlzKopieren',
  host: { '(click)': 'kopieren()' },
})
export class PlzKopierenDirective {
  private readonly clipboard = inject(Clipboard)

  readonly plz = input<string | null | undefined>(undefined, { alias: 'libPlzKopieren' })

  readonly hinweis = computed(() => {
    const plz = this.plz()
    return plz ? `Kopiert dabei die PLZ ${plz}` : ''
  })

  protected kopieren() {
    const plz = this.plz()
    if (plz) {
      this.clipboard.copy(plz)
    }
  }
}
